import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty(target, key, source[key]);
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import { mapComponentThemes } from "../themes";
import { pxToEm } from "../styles";
import { overflowContainerTheme } from "../OverflowContainer/themes"; // $FlowFixMe - strict theme keys incompatible with mapComponentThemes

export var tableTheme = function tableTheme(baseTheme) {
  return mapComponentThemes({
    name: 'OverflowContainer',
    theme: overflowContainerTheme(baseTheme)
  }, {
    name: 'Table',
    theme: {}
  }, baseTheme);
};
export var tableCellTheme = function tableCellTheme(baseTheme) {
  return _objectSpread({
    TableCell_borderVertical: null,
    TableCell_borderVertical_highContrast: null,
    TableCell_fontSize: baseTheme.fontSize_ui,
    TableCell_paddingHorizontal: baseTheme.space_inline_md,
    TableCell_paddingVertical: baseTheme.space_stack_sm,
    TableCell_paddingVertical_spacious: pxToEm(12),
    TableCell_verticalAlign: 'top'
  }, baseTheme);
};
export var tableHeaderTheme = function tableHeaderTheme(baseTheme) {
  return _objectSpread({
    TableHeader_borderBottom: "2px solid " + baseTheme.borderColor,
    TableHeader_borderBottom_highContrast: "2px solid " + baseTheme.color_gray_80,
    TableHeader_borderTop: "1px solid " + baseTheme.borderColor,
    TableHeader_borderTop_highContrast: "1px solid " + baseTheme.color_gray_80
  }, baseTheme);
}; // prettier-ignore
// $FlowFixMe - strict theme keys incompatible with mapComponentThemes

export var tableHeaderCellTheme = function tableHeaderCellTheme(baseTheme) {
  return mapComponentThemes({
    name: 'TableCell',
    theme: tableCellTheme(baseTheme)
  }, {
    name: 'TableHeaderCell',
    theme: {
      TableHeaderCell_borderVertical: "1px dotted " + baseTheme.borderColor,
      TableHeaderCell_borderVertical_highContrast: "1px dotted " + baseTheme.color_gray_80,
      TableHeaderCell_fontWeight: baseTheme.fontWeight_bold,
      TableHeaderCell_paddingHorizontal: baseTheme.space_inline_md,
      TableHeaderCell_paddingVertical: pxToEm(12),
      TableHeaderCell_paddingVertical_spacious: baseTheme.space_stack_md,
      TableHeaderCell_verticalAlign: 'bottom'
    }
  }, baseTheme);
}; // prettier-ignore

export var tableRowTheme = function tableRowTheme(baseTheme) {
  return _objectSpread({
    TableRow_backgroundColor_highContrast_selected: baseTheme.color_theme_20,
    TableRow_backgroundColor_highContrast_selectedHover: baseTheme.color_theme_30,
    TableRow_backgroundColor_hover: baseTheme.color_gray_20,
    TableRow_backgroundColor_selected: baseTheme.color_theme_10,
    TableRow_backgroundColor_selectedHover: baseTheme.color_theme_20,
    TableRow_backgroundColor_striped: baseTheme.color_gray_10,
    TableRow_borderHorizontal: "1px solid " + baseTheme.color_white,
    TableRow_borderHorizontal_highContrast: "1px solid " + baseTheme.color_gray_60
  }, baseTheme);
}; // prettier-ignore

export var tableSortableHeaderCellTheme = function tableSortableHeaderCellTheme(baseTheme) {
  return _objectSpread({
    TableSortableHeaderCell_border_focus: "1px solid " + baseTheme.borderColor_theme_focus,
    TableSortableHeaderCell_color_focus: baseTheme.color_theme,
    TableSortableHeaderCell_color_hover: baseTheme.icon_color_theme,
    TableSortableHeaderCellIcon_size: pxToEm(14)
  }, baseTheme);
};
export var tableTitleTheme = function tableTitleTheme(baseTheme) {
  return _objectSpread({
    TableTitle_color: baseTheme.h4_color,
    TableTitle_fontSize: baseTheme.h4_fontSize,
    TableTitle_fontWeight: baseTheme.h4_fontWeight,
    TableTitle_marginBottom: baseTheme.space_stack_sm
  }, baseTheme);
};